/**
 * IDs werden auf dem Gerät vergeben, damit die App offline neue Etappen,
 * Ausgaben und Fotos anlegen kann. Der Server prüft sie nur noch auf Form.
 */

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789'

/**
 * Erzeugt eine kurze, zufällige ID. Nur Zeichen aus [A-Za-z0-9_-], weil
 * Foto-IDs auf dem Server zu Dateinamen werden.
 *
 * @param prefix Kürzel, das die Art erkennbar macht, etwa "s" für Etappe.
 */
export function newId(prefix = ''): string {
  const bytes = new Uint8Array(8)
  crypto.getRandomValues(bytes)
  let out = ''
  for (const b of bytes) out += ALPHABET[b % ALPHABET.length]
  return prefix + out
}
